import ajax from '../../lib/ajax';
import util from '../../lib/util';
import { Store, Module, ActionContext } from 'vuex';
import _ from 'lodash'
interface SessionState {
	application: any;
	user: any;
	tenant: any;
	client: any;
    notifications:any,
	notificationTotalCount:number
}
class SessionStore implements Module<SessionState, any> {
	namespaced = true;
	state = {
		application: null,
		user: null,
		tenant: null,
		client: null,
        notifications : new Array<any>(),
		notificationTotalCount:0
	};
	actions = {
		async init(content: ActionContext<SessionState, any>) {
			let rep = await ajax.get('/api/services/app/Session/GetCurrentLoginInformations', {
				headers: {
					'Abp.TenantId': util.abp.multiTenancy.getTenantIdCookie(),
				},
			});
			content.state.application = rep.data.result.application;
			content.state.user = rep.data.result.user;
			content.state.tenant = rep.data.result.tenant;
			content.state.client = rep.data.result.client;
			if(!_.isNil(rep.data.result.userNotifications) && !_.isNil(rep.data.result.userNotifications.items))
			{
				content.state.notifications = rep.data.result.userNotifications.items;
				content.state.notificationTotalCount = rep.data.result.userNotifications.totalCount;
			}
			return rep.data.result;
		},
	};
}
const session = new SessionStore();
export default session;
